
import insuranceGuideQuery from '@/apollo/queries/home/insuranceguide'

const relatedBlogLogic = [
  {
    route: "/products/medical",
    requiredQuery: ["geo=85"],
    tagCodes: ["international-medical"],
  },
  {
    route: "/products/medical",
    requiredQuery: ["vhistype=45"],
    tagCodes: ["vhis"],
  },
  {
    route: "/products/medical",
    requiredQuery: ["roomtype=66"],
    tagCodes: ["mass-medical"],
  },
  {
    route: "/products/medical",
    requiredQuery: ["roomtype=67"],
    tagCodes: ["high-end-medical"],
  },
  {
  route: "/products/medical",
  requiredQuery: [],
  tagCodes: ["mass-medical"],
  },
  {
  route: "/products/short-term-savings",
  requiredQuery: [],
  tagCodes: ["short-term-savings"],
  },
  {
  route: "/products/long-term-savings",
  requiredQuery: [],
  tagCodes: ["long-term-savings"],
  },
  {
  route: "/products/term-critical-illness",
  requiredQuery: [],
  tagCodes: ["term-critical-illness"],
  },
  {
  route: "/products/whole-life-critical-illness",
  requiredQuery: [],
  tagCodes: ["whole-life-critical-illness"],
  },
  {
  route: "/products/term-cancer",
  requiredQuery: [],
  tagCodes: ["term-cancer"],
  },
  {
  route: "/products/term-life",
  requiredQuery: [],
  tagCodes: ["term-life"],
  },
  {
  route: "/products/whole-life-protection",
  requiredQuery: [],
  tagCodes: ["whole-life-insurance"],
  },
  {
  route: "/products/travel",
  requiredQuery: [],
  tagCodes: ["travel"],
  },
  {
  route: "/products/home",
  requiredQuery: [],
  tagCodes: ["home-insurance"],
  },
  {
  route: "/products/personal-accident",
  requiredQuery: [],
  tagCodes: ["accident"],
  },
  {
  route: "/products/deferred-annuity",
  requiredQuery: [],
  tagCodes: ["qdap"],
  },
  {
  route: "/products/deferred-annuity",
  requiredQuery: ["objective=retirement"],
  tagCodes: ["qdap"],
  },
  {
  route: "/products/deferred-annuity",
  requiredQuery: ["objective=longevity"],
  tagCodes: ["qdap"],
  },
  {
  route: "/products/immediate-annuity",
  requiredQuery: [],
  tagCodes: ["annuity"],
  },
];

export default {
  data() {
    return {
    };
  },
  computed: {
    quickGuideData() {
      const data = {};
      try {
        if (!this.quickGuide?.insuranceGuides && !this.quickGuide?.blogs)  return null;

        if (this.quickGuide?.insuranceGuides) {
          data.insuranceGuides = this.quickGuide?.insuranceGuides[0];
        } 
        if (this.quickGuide?.blogs) {
          data.relatedBlogs = this.quickGuide?.blogs;
        }
        return data;
      } catch (error) {
        console.error('error: ', error);
        this.$sentry.captureException(error);
        return null;
      }
    },
    quickGuideContentAnchorData() {
      if (this.quickGuide?.insuranceGuideContentAnchor) {
        return this.quickGuide?.insuranceGuideContentAnchor;
      }
      return null;
    },
    quickGuidTagCodes() {
      return this.getTagCodes();
    }
  },
  
  async asyncData({ route }) {
    return {
      currentPath: route.path,
      currentQueryString: route.query
    };
  },

  methods: {
    getTagCodes() {
      try
      {
        const currentRoute = (this.currentPath).replace(/^\/(zh-HK|en|zh-CN)/, '');
        const rules = relatedBlogLogic.filter((item) => item.route === currentRoute);

        if (rules.length > 0) {
          const blogTagCodes = rules.find((rule) => {
            const requiredQuery = rule.requiredQuery;
            const query = this.currentQueryString;
            const queryString = Object.entries(query).map(([key, value]) => `${key}=${value}`).join('&');
            return requiredQuery.every(item => queryString == item);
          })
          console.debug('blogTagCodes: ', blogTagCodes);
          return blogTagCodes?.tagCodes || [];
        }
        return [];
      } catch (error) {
        console.error('error: ', error);
        this.$sentry.captureException(error);
        return [];
      }
    },
  },

  apollo: {
    quickGuide: {
      prefetch: true,
      query: insuranceGuideQuery,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale), slug: this.slug, tagCodes: this.quickGuidTagCodes }
      },
      update(data) {
        return this.$normalizeStrapi(data);
      },
    },
  },

  mounted() {
  }
}